import { InjectionToken, StaticProvider } from '@angular/core';

import { BaseApiConfig } from '../../models/base-api-config.model';

/**
 * Provides API configuration for the Billing page's card on file and receipts.
 *
 * The `BillingAccountApiConfig` is injected via `BILLING_ACCOUNT_API_CONFIG`
 */

export type BillingAccountApiConfig = BaseApiConfig<{
  getPaymentMethod: string;
  updatePaymentMethod: string;
  createSetupIntent: string;
  getReceipts: string;
}>;

export const BILLING_ACCOUNT_API_CONFIG = new InjectionToken<BillingAccountApiConfig>('BILLING_ACCOUNT_API_CONFIG');

export const provideBillingAccountApiConfig = (config: BillingAccountApiConfig): StaticProvider => ({
  provide: BILLING_ACCOUNT_API_CONFIG,
  useValue: config,
});
